<template>
  <div class="col-12 col-md-4 col-lg-3">
    <a :href="'/proceso_financiamiento/' + id" style="color: inherit; text-decoration: none;">
      <div class="pricing p-2 pt-4">
        <label class="d-block text-center font-weight-bold cl-advancepñd-consulting">Versión</label>
        <h2 class="text-center">{{title}}</h2>
        <h4 class="text-center"><sup style="font-size: 17px;">$</sup>{{ monthlyCost }}.00<span style="font-size: 15px;">MXN/Mes</span></h4>
        <br>
        <table class="table table-striped">
          <tbody>
          <tr class="text-center">
            <td class="min-height-td-pricing">
              <strong class="">Enganche:</strong><br>
              <p>{{ Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(initialPayment ? initialPayment : '00') }}</p>
            </td>
          </tr>
          <tr class="text-center">
            <td class="min-height-td-pricing">
              <strong class="">Al mes:</strong><br>
              <p>{{ Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(monthlyCost ? monthlyCost : '00') }}.00</p>
            </td>
          </tr>
          <tr class="text-center">
            <td class="min-height-td-pricing">
              <strong class="">Disponibles:</strong><br>
              <p>{{ stock }} ¡Aprovecha!</p>
            </td>
          </tr>
          <tr class="text-center">
            <td class="p-0">
              <a :href="'/proceso_financiamiento/' + id" class="btn nw-buttons text-light d-block mx-auto bg-advanced-consulting"><h5>¡Lo quiero!</h5></a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'CarVersion',
  props: {
    id: Number,
    title: String,
    promotionCost: Number,
    initialPayment: Number,
    monthlyCost: Number,
    imgVercion: {
      default: '@/assets/images/carVersiones.svg',
      type: String
    },
    stock: Number
  }
}
</script>

<style scoped>

</style>
